import MultiPromoA from "./MultiPromoA.jsx";
import MultiPromoB from "./MultiPromoB.jsx";
import MultiPromoC from "./MultiPromoC.jsx";
import MultiPromoVideo from "./MultiPromoVideo.jsx";

import ReactDom from "react-dom";

export default function renderMultiPromo() {
  document.querySelectorAll(".js-multi-promo-mount").forEach((mount, i) => {
    const dataModel = JSON.parse(mount.dataset.model);

    dataModel &&
      dataModel.type === "carousels" &&
      ReactDom.render(<MultiPromoA index={i} {...dataModel} />, mount);

    dataModel &&
      dataModel.type === "cards" &&
      ReactDom.render(<MultiPromoB index={i} {...dataModel} />, mount);

    dataModel &&
      dataModel.type === "grid" &&
      ReactDom.render(<MultiPromoC index={i} {...dataModel} />, mount);

    dataModel &&
      dataModel.type === "video" &&
      ReactDom.render(<MultiPromoVideo index={i} {...dataModel} />, mount);
  });
}
